module.exports = __webpack_public_path__ + "static/img/4.6bc32af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/eng/4.png
// module id = I0VI
// module chunks = 0